export const dropdownConstants = {
    DROPDOWN_UPDATE: "DROPDOWN_UPDATE"
  };
  